module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/7c3facb4806a15bf8a0bfe05940cecf2.png";